import { v_InvoiceLineItemBus } from "./v_InvoiceLineItemBus";
import { InvoicePaymentBus } from "./InvoicePaymentBus";
import { v_InvoiceServicedEquipmentBus } from "./v_InvoiceServicedEquipmentBus";
import { InvoiceNoteBus } from "./InvoiceNoteBus";
import { v_InvoiceDetailBus } from './v_InvoiceDetailBus'
import { v_InvoiceNoteBus } from "./v_InvoiceNoteBus";
import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class v_InvoiceBus extends BaseBus
{
  constructor(data: v_InvoiceBus = null)
  {
      super(data);
     if (data != null) {
      this.invoiceDate = DateFunctions.getDate(data.invoiceDate);
      this.invoiceDetail = data.invoiceDetail;
      this.lineItems = data.lineItems;
      this.invoiceServicedEquipment = data.invoiceServicedEquipment;
      this.invoicePayments = data.invoicePayments;
      this.invoiceNotes = data.invoiceNotes;
    }
  }
  public invoiceId: any;
  public locationName: string;
  public invoiceDate: Date;
  public invoiceNumber: string;
  public salesPersonName: string;
  public ponumber: string;
  public wonumber: string;
  public invoiceStatusName: string;
  public invoiceDesc: string;
  public terms: string;
  public taxAmount: number;
  public amount: number;
  public total: number;
  public payments: number;
  public balanceDue: number;
  public invoiceDetail: v_InvoiceDetailBus;
  public Phone: string;
  public addressLine1: string;
  public addressLine2: string;
  public city: string;
  public stateProvince: string;
  public postalCode: string;
  public CO: number;
  public isOpen: boolean;
  public isActiveLocation: boolean;
  public customerId: any;
  public locationId: any;
  public invoiceStatusId: any;
  public discreetBillerId: any;
  public defaultSubmitterId: any;
  public dispatchId: any;
  public dispatchNumber: string;
  public isConstruction: boolean
  public amNote: string;
  public avalarataxableAmount: number;
  public lineItems: v_InvoiceLineItemBus[];
  public invoiceServicedEquipment: v_InvoiceServicedEquipmentBus[];
  public invoicePayments: InvoicePaymentBus[];
  public invoiceNotes: v_InvoiceNoteBus[];
}
